import { Route } from 'vue-router'

/**
 * keySetで指定したクエリがある場合は遷移先ページに引き継ぐ /  to.queryに同一keyの値が存在する場合は上書きは行わない
 * @param from Route
 * @param to Route
 * @param keySet Set<string>
 * @returns toのRoute（keySetで指定したqueryのうち、いずれか一つでも更新した場合のみ）
 */
export const attachQueryParamsIfNeeded = (
  to: Route,
  from: Route,
  keySet: Set<string>
): { path?: string; name?: string; query: Record<string, any> } | undefined => {
  const newQuery = { ...to.query }
  let isQueryUpdated = false

  for (const key of keySet) {
    const fromValue = from.query[key]
    if (!fromValue || to.query[key]) {
      continue
    }
    newQuery[key] = fromValue
    isQueryUpdated = true
  }

  if (isQueryUpdated) {
    return {
      ...(to.path ? { path: to.path } : to.name ? { name: to.name } : {}),
      query: newQuery,
    }
  }
}
